import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Zap, ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, children }) {
  useEffect(() => { document.documentElement.classList.add("dark"); }, []);
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-40 border-b border-border backdrop-blur-xl bg-background/70">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="h-8 w-8 grid place-items-center bg-primary text-primary-foreground rounded">
              <Zap className="h-4 w-4" strokeWidth={2.5}/>
            </div>
            <div className="font-display font-black tracking-tight text-xl">ContentOS</div>
          </Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-1">
            <ArrowLeft className="h-3.5 w-3.5"/> Home
          </Link>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-6 py-14">
        <div className="text-xs uppercase tracking-widest text-muted-foreground font-bold">Legal</div>
        <h1 className="mt-2 font-display font-black text-4xl sm:text-5xl tracking-tighter leading-[0.95]">{title}</h1>
        {updated && (
          <div className="mt-3 font-mono text-xs text-muted-foreground">Last updated: {updated}</div>
        )}
        <div className="prose-content mt-10 space-y-6 text-[15px] leading-relaxed text-foreground/90">
          {children}
        </div>
      </article>

      <footer className="border-t border-border py-8 mt-10">
        <div className="max-w-3xl mx-auto px-6 flex flex-wrap items-center justify-between gap-3 text-xs text-muted-foreground">
          <div>© 2026 ContentOS · Post smarter, not more.</div>
          <div className="flex gap-4">
            <Link to="/terms" className="hover:text-foreground">Terms</Link>
            <Link to="/privacy" className="hover:text-foreground">Privacy</Link>
            <Link to="/refunds" className="hover:text-foreground">Refunds</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export const H2 = ({ children }) => (
  <h2 className="font-display font-bold text-xl mt-8 tracking-tight text-foreground">{children}</h2>
);
export const P = ({ children }) => (
  <p className="text-muted-foreground leading-relaxed">{children}</p>
);
export const UL = ({ children }) => (
  <ul className="list-disc pl-5 space-y-1.5 text-muted-foreground marker:text-primary">{children}</ul>
);
